module.exports = __webpack_public_path__ + "static/media/Frame.fd128615.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_170/img/Frame.png
// module id = 1507
// module chunks = 0